import { Component, OnInit, Input } from '@angular/core';
import { BillingCard } from '../models/billing-card';

@Component({
  selector: 'dac-billing-card',
  templateUrl: './billing-card.component.html',
  styleUrls: ['./billing-card.component.scss']
})
export class BillingCardComponent implements OnInit {

  // TODO: stephen go through and add the card images here.
  @Input() card:BillingCard;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/billing-card/billing-card.component.ts